<template>
  <div class="question-list">
    <FilterGrid
      :only="['accordion']"
      :clear-button="false"
      :on-accordion-select="value => this.onSelectFilter(value)"
      :use-sub-selection="useSubSelection"
      :selected-levels="selectedLevels"
      :selected-question="selectedQuestion"
    />
  </div>
</template>

<script>
export default {
  name: 'QuestionList',
  props: {
    useSubSelection: {
      type: Boolean,
      default: false
    },
    selectedQuestion: {
      type: Object,
      default: null
    },
    selectedLevels: {
      type: Object,
      default: null
    }
  },
  methods: {
    onSelectFilter (value) {
      this.$emit('onSelectQuestion', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.question-list {
  background-color: #edf1f7;
  border-radius: 4px;
  padding: 8px;
}
</style>
